import { useEffect, type ReactNode } from "react";
import { usePortalAuth } from "./PortalAuthProvider";
import { Center, Loader } from "@mantine/core";

interface PortalProtectedRouteProps {
  children: ReactNode;
  loginPath?: string;
}

export function PortalProtectedRoute({
  children,
  loginPath = "/login",
}: PortalProtectedRouteProps) {
  const { isAuthenticated, isLoading } = usePortalAuth();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      window.location.href = loginPath;
    }
  }, [isAuthenticated, isLoading, loginPath]);

  if (isLoading) {
    return (
      <Center h="100vh">
        <Loader size="lg" />
      </Center>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  return <>{children}</>;
}
